module.exports = __webpack_public_path__ + "img/full-slide-7.e69500ac.jpg";